import React from "react";

const PixelPortraits = React.lazy(() =>
  import("./projects/pixelPortraits/PixelPortraits")
);
const BinaryHands = React.lazy(() =>
  import("./projects/binaryHands/BinaryHands")
);
const EyeDiagrams = React.lazy(() =>
  import("./projects/eye-diagrams/EyeDiagrams")
);
const PixelStretcher = React.lazy(() =>
  import("./projects/pixel-stretcher/PixelStretcher")
);
const ArtyFarties = React.lazy(() =>
  import("./projects/art-pifflator/ArtPifflator")
);
const DrawMeAPhoto = React.lazy(() =>
  import("./projects/draw-me-a-photo/DrawMeAPhoto")
);
const PutFacesOnThings = React.lazy(() =>
  import("./projects/put-faces-on-things/PutFacesOnThings")
);
const ScreamingPhotos = React.lazy(() =>
  import("./projects/screaming-photos/ScreamingPhotos")
);
const EndlessDithering = React.lazy(() =>
  import("./projects/endless-dithering/EndlessDithering")
);
const PainThreshold = React.lazy(() =>
  import("./projects/pain-threshold/PainThreshold")
);
const Pixelator = React.lazy(() => import("./projects/pixelator/Pixelator"));
const HamaTime = React.lazy(() => import("./projects/hama-time/HamaTime"));
const ColourSplitter = React.lazy(() =>
  import("./projects/colour-splitter/ColourSplitter")
);
const ImageManipulation = React.lazy(() =>
  import("./projects/image-manipulation/ImageManipulation")
);
const PortraitGrids = React.lazy(() =>
  import("./projects/portrait-grids/PortraitGrids")
);
const ColourReducer = React.lazy(() =>
  import("./projects/colour-reducer/ColourReducer")
);
const MakeyTalky = React.lazy(() =>
  import("./projects/makey-talky/MakeyTalky")
);
const TwirlyFrameTest = React.lazy(() =>
  import("./projects/twirly-frame-test/TwirlyFrameTest")
);
const Tiled = React.lazy(() => import("./projects/tiled/Tiled"));
const SplitPhotos = React.lazy(() =>
  import("./projects/split-photos/SplitPhotos")
);
const DoubleExposure = React.lazy(() =>
  import("./projects/double-exposure/DoubleExposure")
);
const OddBlocks = React.lazy(() => import("./projects/oddBlocks/OddBlocks"));
const Weaver = React.lazy(() => import("./projects/weaver/Weaver"));
const Eraser = React.lazy(() => import("./projects/eraser/Eraser"));
const PhotoJoiner = React.lazy(() =>
  import("./projects/photo-joiner/PhotoJoiner")
);

// eslint-disable-next-line

// Empty template
/*
{
    comp: PixelStretcher,
    url: '',
    title: '',
    linkText: '',
    description: ''
},
*/

export const projects = [
  {
    comp: <PixelPortraits />,
    showInSidebar: true,
    draft: true,
    url: "pixel-portraits",
    title: "Pixel Portraits",
    linkText: "Painting by pixels.",
    description: "Paint one jumbo pixel at at time."
  },
  {
    comp: <EyeDiagrams />,
    showInSidebar: true,
    draft: true,
    url: "eye-diagrams",
    title: "Eye Diagrams",
    linkText: "Take a looksee",
    description: "Interactive eye diagrams - show / hide labels etc."
  },
  {
    comp: <BinaryHands />,
    showInSidebar: true,
    url: "binary-hands",
    title: "Binary Hands",
    linkText: "You can count on me",
    description:
      "Counting on fingers using binary.  The devil makes work for binary hands - especially 438!"
  },
  {
    comp: <Pixelator />,
    showInSidebar: true,
    draft: true,
    url: "pixelator",
    title: "The Pixelator",
    linkText: "2, 4, 6, 8, Pixelate",
    description: "We're all made of pixels. Pixels to the core."
  },
  {
    comp: <Eraser />,
    showInSidebar: true,
    draft: true,
    url: "eraser",
    title: "Eraser",
    linkText: "Let's Rub stuff out",
    description:
      "Erase parts of an image.  Saves a .png with the erased parts set to be be transparent."
  },
  {
    comp: <OddBlocks />,
    showInSidebar: false,
    draft: true,
    url: "odd-blocks",
    title: "Odd Blocks",
    linkText: "You'll be in pieces",
    description:
      "Turns image into blocks, but misses some out or rearranges them."
  },
  {
    comp: <Weaver />,
    showInSidebar: true,
    url: "weaver",
    title: "Weaver",
    linkText: "Get Wove",
    description: "Interlace two photos."
  },
  {
    comp: <SplitPhotos />,
    showInSidebar: false,
    url: "split-photos",
    title: "Split Photos",
    linkText: "Divide and conquer (or conker)",
    description: "Mix two pictures together"
  },
  {
    comp: <DoubleExposure />,
    showInSidebar: false,
    url: "double-exposure",
    title: "Double Exposure",
    linkText: "Over the top",
    description: "Blend one photo over another."
  },
  {
    comp: <PhotoJoiner />,
    showInSidebar: true,
    draft: false,
    url: "photo-joiner",
    title: "Photo Joiner",
    linkText: "Diptych, Triptych and tychs beyond",
    description: "Join photos together."
  },
  {
    comp: <Tiled />,
    showInSidebar: true,
    draft: false,
    url: "tiled",
    title: "Tiled",
    linkText: "No Grout needed",
    description: "Generate some randomised tile art."
  },
  {
    comp: <DrawMeAPhoto />,
    draft: false,
    url: "draw-me-a-photo",
    title: "Draw Me a Photo",
    linkText: "Pencils Ready",
    description: "Turn a photo into a pencil sketch"
  },
  {
    comp: <TwirlyFrameTest />,
    draft: true,
    url: "twirly-frame-test",
    title: "Twirly Frame Test",
    linkText: "A frame for royalty",
    description: "Resizeable twirly frame."
  },
  {
    comp: <MakeyTalky />,
    draft: true,
    url: "makey-talky",
    title: "Head, Shoulders, Makey, Talky",
    linkText: "Talk to me",
    description: "Trigger speech by touch a drawing in REAL LIFE!"
  },
  {
    comp: <ColourReducer />,
    draft: true,
    url: "colour-reducer",
    title: "Colour Reducer",
    linkText: "Remove colour from your cheeks",
    description: "Reduce the number of colours in a photo."
  },
  {
    comp: <PortraitGrids />,
    showInSidebar: true,
    url: "portrait-grids",
    title: "Portrait Grid maker",
    linkText: "You squared",
    description: "A tool to create image grids over your photos."
  },
  {
    comp: <ColourSplitter />,
    showInSidebar: true,
    url: "colour-splitter",
    title: "Colour Splitter",
    linkText: "Let's Tracey Thorn this up",
    description:
      'Tracey Thorn puts it best: "It\'s where I\'d like to be, is on a dancefloor with some drinks inside of me." OR to read between the lines "split into my underlying constituent colours".  An attempt to create something like Tracey Thorn\'s album cover for "Record" because I\'ve been listening to Dancefloor remixes all day!!!'
  },
  {
    comp: <HamaTime />,
    draft: true,
    url: "hama-time",
    title: "It's Hama Time",
    linkText: "Can't stop this",
    description: ""
  },
  {
    comp: <ScreamingPhotos />,
    draft: true,
    url: "screaming-photos",
    title: "Screaming Photos",
    linkText: "Face facts...",
    description:
      "Turn photos into beautiful music / nightmarish cacophonies... you decide."
  },
  {
    comp: <EndlessDithering />,
    draft: true,
    url: "endless-dithering",
    title: "Endless Dithering",
    linkText: "endless-dithering",
    description: "..."
  },
  {
    comp: <PutFacesOnThings />,
    draft: true,
    url: "put-faces-on-things",
    title: "Faces on Things",
    linkText: "Face facts...",
    description:
      "Pareidolia: Seeing faces on things. See Jesus on a dishcloth, Elvis on a toastie and Trump on loo roll."
  },
  {
    comp: <ImageManipulation />,
    draft: true,
    url: "image-filters",
    title: "Image filters",
    linkText: "Ter Fil is to live",
    description: "All the filters for my ref only I think."
  },
  {
    comp: <PainThreshold />,
    url: "pain-threshold",
    title: "Pain Threshold",
    linkText: "Let Us Thresh",
    description: "Playing around with colour thresholds... Not sure why."
  },
  {
    comp: <PixelStretcher />,
    showInSidebar: true,
    url: "pixel-stretcher",
    title: "Pixel Stretcher",
    linkText: "...and Stretch",
    description:
      "An effect based one used by Spike Jonze in his music video for Apple."
  },
  {
    comp: <ArtyFarties />,
    url: "art-pifflator",
    title: "Art Pifflator",
    linkText: "Go forth and create waffle",
    description:
      "Let's make piffle. Generate florid descriptions of your artworks with all the sincerity an automated bot can muster."
  }
];



// WEBPACK FOOTER //
// ./src/PROJECTS.js